import "./css/Login.css";

// Dependencies
import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { TextField, FormControl } from "@mui/material";
import axios from "../../../lib/axios";

// Components
import LoginGoogle from "./LoginGoogle";
import LoginGuest from "./LoginAsGuest";
import PhysioTracker from "../../Landing/components/PhysioTracker";
import { ButtonLanding } from "../../../components/Buttons";

// Hooks
import useSetTokenState from "../hooks/useSetTokenState";
import { useNavigate } from "react-router-dom";
import useUserLogin from "../hooks/useUserLogin";
import useManageInput from "../hooks/useManageInput";
import AuthSectionContainer from "./AuthSectionContainer";
import ResponseStatus from "./ResponseStatus";

// Icons

function Login() {
  const emailRef = useRef();

  useEffect(() => {
    emailRef.current.focus();
  }, []);

  const {
    value: email,
    valueIsValid: emailIsValid,
    error: emailError,
    setValue: setEmail,
    setError: setEmailError,
    showError: showEmailError,
  } = useManageInput("email", {
    required: true,
    rule: {
      regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Invalid email",
    },
  });

  const {
    value: password,
    valueIsValid: passwordIsValid,
    error: passwordError,
    setValue: setPassword,
    setError: setPasswordError,
    showError: showPasswordError,
  } = useManageInput("password", {
    required: true,
    minChar: 6,
  });

  const handleRequestError = (errors) => {
    if (!errors) return;
    setEmailError(errors?.password?.[0]);
    setPasswordError(errors?.password?.[0]);
  };

  const [loginHandler, loggingIn, loginError] = useUserLogin();

  const handleSubmit = async (e) => {
    e.preventDefault();

    showEmailError();
    showPasswordError();

    if (emailIsValid && passwordIsValid) {
      const response = await loginHandler(email, password);

      if (!response) return;

      handleRequestError(response);
    }
  };

  return (
    <AuthSectionContainer className={"login"} title={"Login"}>
      <ResponseStatus status={"error"}>{loginError}</ResponseStatus>
      <form onSubmit={handleSubmit}>
        <FormControl>
          <p className="error-message">{emailError && emailError}</p>
          <TextField
            id="email"
            label="Email"
            variant="outlined"
            size="normal"
            type="text"
            value={email}
            fullWidth
            inputRef={emailRef}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            error={emailError ? true : false}
            autoComplete="new-password"
          />
        </FormControl>
        <FormControl>
          <p className="error-message">{passwordError && passwordError}</p>
          <TextField
            id="password"
            label="Password"
            variant="outlined"
            size="normal"
            type="password"
            value={password}
            fullWidth
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            error={passwordError ? true : false}
            autoComplete="new-password"
          />
        </FormControl>

        <Link to={"/forgot-pw"} className="redirect">
          Forgot password?
        </Link>
        <ButtonLanding
          type="submit"
          name="Login"
          style={{ marginTop: "0.3rem" }}
          loading={loggingIn}
        />
      </form>

      <div className="login-redirect">
        <p>
          Don't have an account?
          <Link to={"/sign-up"} className="redirect">
            Sign up
          </Link>
        </p>
      </div>
      <div className="login-hr">
        <div className="line">
          <div></div>
        </div>
        <div className="words">or</div>
        <div className="line">
          <div></div>
        </div>
      </div>
      <div className="login-alt">
        <LoginGuest />
        <LoginGoogle />
      </div>
    </AuthSectionContainer>
  );
}

export default Login;
